import React from 'react';
import { IconButton, useTheme, useMediaQuery } from '@mui/material';
import Button from './Button';

const SocialLoginButton = ({ text, icon, onClick, variant = 'outlined', bg = 'white', fullWidth = true, sx = {} }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const defaultSx = {
    borderRadius: '50px',
    color: 'black',
    border: '1px solid lightgrey',
    fontSize: '14px',
    ...sx,
  };

  const mobileSx = {
    borderRadius: '50px',
    color: 'black',
    border: '1px solid lightgrey',
    bgcolor: 'white',
    width: '100%',
    height: '40px',
    '&:hover': {
      bgcolor: 'white',
      border: '1px solid lightgrey',
    },
  };

  if (isMobile) {
    return (
      <IconButton onClick={onClick} sx={mobileSx}>
        {icon}
      </IconButton>
    );
  }

  return (
    <Button
      text={text}
      variant={variant}
      startIcon={icon}
      bg={bg}
      fullWidth={fullWidth}
      onClick={onClick}
      sx={defaultSx}
    />
  );
};

export default SocialLoginButton;
